// 测试环境
// let proxyUrl = 'https://jnc.lishine2023.top/api';
// const imgUrl = 'https://jnc.lishine2023.top';
// if (process.env.NODE_ENV == 'development') {
//     proxyUrl = 'https://jnc.lishine2023.top/api'
// }


// 正式环境
let proxyUrl = 'https://www.jnc.cn/api';
const imgUrl = 'https://www.jnc.cn';
if (process.env.NODE_ENV == 'development') {
    proxyUrl = 'https://www.jnc.cn/api'
}

export {
    proxyUrl,
    imgUrl
}
